module.exports = __webpack_public_path__ + "housingStatic/img/moudle_name_item1.00e3dd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_center/moudle_name_item1.png
// module id = voiC
// module chunks = 2